<div class="tw-flex tw-flex-col tw-basis-full tw-items-stretch">

    <section class="page-content tw-flex tw-basis-full">
        <div class="scroll-container">
            <div class="scroll-content">

                <section class="tw-flex tw-basis-full tw-flex-wrap">

                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>
                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>
                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>
                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>
                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>
                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>
                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>
                    <div class="tw-flex tw-basis-1/3 tw-h-96 tw-p-2">
                        <section class="tw-flex tw-basis-full tw-h-full bg-blue-500 tw-rounded"></section>
                    </div>

                </section>

            </div>
        </div>
    </section>

</div>
